import { render } from "./TvmFeatureTiles.vue?vue&type=template&id=3890eefc&scoped=true"
import script from "./TvmFeatureTiles.vue?vue&type=script&lang=js"
export * from "./TvmFeatureTiles.vue?vue&type=script&lang=js"

import "./TvmFeatureTiles.vue?vue&type=style&index=0&id=3890eefc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3890eefc"]])

export default __exports__